import * as React from 'react';
import { SectionTitleFontSizeProps } from './SectionTitle.utils';
import { useTheme } from '../../../theming/useTheme';
import { H2 } from '../../../typography/semanticTags';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigThemeKey = 'secondarySectionTitle';

export const SecondarySectionTitle: React.FunctionComponent = props => {
  const { children } = props;
  const theme = useTheme<SectionTitleFontSizeProps>(componentConfigThemeKey);

  return (
    <ErrorBoundary>
      <H2 {...theme}>
        {children}
      </H2>
    </ErrorBoundary>
  );
};
